import { Input } from "antd";
import { useTranslation } from "react-i18next";

/**
 * Filters function renders the search filter UI.
 * @param {object} props - Props object containing the callback function.
 * @param {function} props.setSearchString - Function to update the search string.
 * @returns {JSX.Element} The rendered Filters component.
 */
export default function Filters({ setSearchString }) {
  return (
    <div className="integrationListFilters">
      <Search setSearchString={setSearchString} />
    </div>
  );
}

/**
 * Renders a search input and handles search actions.
 *
 * @param {Object} props - The properties object.
 * @param {Function} props.setSearchString - Callback function to update the search string.
 * @returns {JSX.Element} The rendered search component.
 */
export function Search({ setSearchString }) {
  const { t } = useTranslation();
  return (
    <div className="search box">
      <Input.Search
        onSearch={(value) => setSearchString(value)}
        size="large"
        placeholder={t("search")}
      />
    </div>
  );
}
